import C from 'actionTypes'

export const setSidebarDataLoaded = data => ({
  type: C.SET_SIDEBAR_DATA_LOADED,
  data
})

export const clearSidebarDataLoaded = () => ({
  type: C.CLEAR_SIDEBAR_DATA_LOADED,
})



// WEBPACK FOOTER //
// ./src/actions/sidebar.js